import { ImportType } from 'modules/domains/adminApp';
import { FractionEnabled } from '../types';

export const isFeatureAffected = (fractionEnabled: FractionEnabled, importType: ImportType) =>
  importType === ImportType.EnableFeature ? fractionEnabled < 1.0 : fractionEnabled > 0.0;
